<template>
  <div class="branding-tab">

    <div class="branding-card">
      <h2 class="card-title">
        {{ $t('pages.settings.branding.logo.title') }}
      </h2>
      <p class="card-description">
        {{ $t('pages.settings.branding.logo.description') }}
      </p>
      <LogoUpload />
    </div>

    <div class="branding-card">
      <h2 class="card-title">
        {{ $t('pages.settings.branding.primaryColor.title') }}
      </h2>
      <p class="card-description">
        {{ $t('pages.settings.branding.primaryColor.description') }}
      </p>
      <PrimaryColorPicker />
    </div>

  </div>
</template>

<script>
import LogoUpload from './LogoUpload.vue'
import PrimaryColorPicker from './PrimaryColorPicker.vue'

export default {
  name: 'BrandingTab',

  components: { LogoUpload, PrimaryColorPicker }
}
</script>

<style lang="scss" scoped>
.branding-tab {
  margin-top: 24px;
}

.branding-card {
  background: #fff;
  border-radius: 8px;
  padding: 32px;
  margin-top: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  &:first-child {
    margin-top: 0;
  }
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
}

.card-description {
  color: #6b6f80;
  margin-bottom: 24px;
}
</style>
